<template>
  <div class='selector'>
    <div class='selector-container'>
      <div class='selector-arrow selector-arrow_left' @click='moveToPreviousDay(true)'></div>
      <div class="selector-txt-container selector-txt-calendar" @click='showVisibilityCalendar()'>
        <div class='selector-ico'>
          <div class='selector-ico-calendar'></div>
        </div>
        <div class='selector-txt'>
          <div id='dateToPrint' class='selector-txt-normal'>
            {{ getCurrentDateLinear }}
          </div>
          <div class='selector-txt-short'>
            {{ getCurrentDateLinearShort }}
          </div>
        </div>
      </div>
      <div class='selector-arrow selector-arrow_right' @click='moveToNextDay(true)'></div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'CalendarNav',
  props: {
    checkLastDay: false
  },
  computed: {
    ...mapGetters({
      getCurrentDateLinear: 'calendar/getCurrentDateLinear',
      getCurrentDateLinearShort: 'calendar/getCurrentDateLinearShort',
      getSelectedDay: 'calendar/getSelectedDay'
    })
  },
  methods: {
    ...mapActions({
      moveToPreviousDay: 'calendar/moveToPreviousDay',
      moveToNextDay: 'calendar/moveToNextDay',
      moveToThisMonthAndDay: 'calendar/moveToThisMonthAndDay',
      findSelectedServiceByDay: 'newServices/findSelectedServiceByDay',
      showVisibilityCalendar: 'calendar/showVisibilityCalendar'
    }),
    goToThisMonthAndDay: function () {
      this.moveToThisMonthAndDay().then(() => {
        this.findSelectedServiceByDay({ date: this.getSelectedDay, init: false, previous: false, keepService: true })
      })
    }
  }
}
</script>

<style lang="scss"></style>
